import React from 'react';
import AddIcon from '../assets/icons/add-blue.svg';

const Button = props => {
  const title = props.title;
  return (
    <div
      className={`editor-button-theme-${props.theme} hoverable ${
        props.disabled ? 'disabled' : ''
      }`}
      onClick={props.onClick}
      style={props.style}
    >
      {props.theme === '7' ? <img src={AddIcon} alt="AddIcon" /> : null}
      {title}
    </div>
  );
};

export default Button;
